import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import IssueTable from "../components/IssueTable";

export default function Issues() {
  const { accounts } = useMsal();
  const navigate = useNavigate();
  const user = accounts[0];

  useEffect(() => {
    if (!user) {
      navigate("/");
    }
  }, [user, navigate]);

  if (!user) return null;

  const columns = [
    { field: "id", headerName: "ID", align: "right" },
    { field: "status", headerName: "Status" },
    { field: "regionalOffice", headerName: "Chorągiew" },
    { field: "districtOffice", headerName: "Hufiec" },
    { field: "created", headerName: "Utworzony" },
    { field: "modified", headerName: "Zmodyfikowany" },
  ];

  return (
    <>
      <Typography variant="h2">Lista zgłoszeń</Typography>
      <Typography variant="body1">
        Przejrzyj zgłoszenia, w których uczestniczysz. Nie zobaczysz tutaj
        zgłoszeń, które zostały przez Ciebie dodane.
      </Typography>
      <IssueTable
        endpoint={process.env.REACT_APP_API_URL + "/api/GetIssues"}
        columns={columns}
        jiraBaseUrl={"https://jira.zhp.pl/plugins/servlet/desk/portal/17/"}
      />
    </>
  );
}
